import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base/base.service';
import { WebApiResponse } from '../../models/types';
import {
  AccessTokenResponse,
  AuditLog,
  CreateSupportGrantRequest,
  GenerateTokenRequest,
  GrantManifest,
  MyPermissionsResponse,
  PaginatedAuditLogs,
  SupportGrant,
} from '../../models/types/resource-access.types';

@Injectable({
  providedIn: 'root',
})
export class ResourceAccessService extends BaseService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  // --- Access Tokens ---

  generateToken(dto: GenerateTokenRequest): WebApiResponse<AccessTokenResponse> {
    return this.post<AccessTokenResponse, GenerateTokenRequest>('resources/tokens', dto);
  }

  revokeToken(tokenId: string): WebApiResponse<void> {
    return this.delete<void>(`resources/tokens/${tokenId}`);
  }

  getDownloadUrl(token: string): string {
    return this.getFullURL(`resources/download/${token}`);
  }

  // --- Audit Logs ---

  getMyAuditLogs(page = 1, limit = 20): WebApiResponse<PaginatedAuditLogs> {
    return this.get<PaginatedAuditLogs>(`audit-logs/me?page=${page}&limit=${limit}`);
  }

  // --- Support Access Grants ---

  previewGrant(dto: CreateSupportGrantRequest): WebApiResponse<GrantManifest> {
    return this.post<GrantManifest, CreateSupportGrantRequest>('support-access/preview', dto);
  }

  createGrant(dto: CreateSupportGrantRequest): WebApiResponse<SupportGrant> {
    return this.post<SupportGrant, CreateSupportGrantRequest>('support-access/grants', dto);
  }

  listMyGrants(includeExpired = false): WebApiResponse<SupportGrant[]> {
    return this.get<SupportGrant[]>(`support-access/grants/me?includeExpired=${includeExpired}`);
  }

  revokeGrant(grantId: string): WebApiResponse<{ revoked: boolean }> {
    return this.delete<{ revoked: boolean }>(`support-access/grants/${grantId}`);
  }

  listGrantsForSupport(): WebApiResponse<SupportGrant[]> {
    return this.get<SupportGrant[]>('support-access/grants/support');
  }

  // --- Resource Permissions ---

  getMyPermissions(resourceType: string, resourceId: string): WebApiResponse<MyPermissionsResponse> {
    return this.get<MyPermissionsResponse>(`resources/${resourceType}/${resourceId}/my-permissions`);
  }
}
